module.exports = __webpack_public_path__ + "static/media/toolbar-lecture.9a8e0da5.svg";